


























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "EntryCode",
  props: {
    code: { type: Object, required: true }
  }
});
